import axios from "axios";
import moment from "moment";

const state = () => ({
  appActionLogs: [],
  latestLogs: [],
  actionTypes: [
    { title: "Get Advertisements", value: "get-advertisements" },
    { title: "Get Config", value: "get-config" },
    { title: "Get Geofences", value: "get-geofences" },
    { title: "Delete Geofences", value: "delete-geofences" },
    { title: "Send Logs", value: "send-logs" },
  ],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1,
    from: 0,
    to: 0,
  },
  filters: {
    startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    search: "",
    sort_by: "date",
    sort_order: "desc",
    course_names: [],
    action: "",
  },
  loading: false,
  latestLogsLoading: false,
});

const mutations = {
  SET_APP_ACTION_LOGS(state, logs) {
    state.appActionLogs = logs;
  },

  SET_PAGINATION(state, pagination) {
    state.pagination = { ...state.pagination, ...pagination };
  },

  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters };
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_LATEST_LOGS(state, logs) {
    state.latestLogs = logs;
  },

  SET_LATEST_LOGS_LOADING(state, loading) {
    state.latestLogsLoading = loading;
  },

  RESET_FILTERS(state) {
    state.filters = {
      startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      search: "",
      sort_by: "time",
      sort_order: "desc",
    };
  },
};

const getters = {
  getActionLogs: (state) => {
    return state.appActionLogs;
  },

  getPagination: (state) => {
    return state.pagination;
  },

  getFilters: (state) => {
    return state.filters;
  },

  isLoading: (state) => {
    return state.loading;
  },
  getActionTypes: (state) => {
    return state.actionTypes;
  },
  getLatestLogs: (state) => {
    return state.latestLogs;
  },
  isLatestLogsLoading: (state) => {
    return state.latestLogsLoading;
  },
};

const actions = {
  async fetchActionLogs({ commit, state, dispatch }, params = {}) {
    commit("SET_LOADING", true);

    const baseUrl = process.env.VUE_APP_API_URL + "/devices/filter-app-logs";

    const apiParams = {
      startDate: state.filters.startDate,
      endDate: state.filters.endDate,
      page: params.current_page || state.pagination.current_page,
      per_page: params.per_page || state.pagination.per_page,
      sort_by: state.filters.sort_by,
      sort_order: state.filters.sort_order,
      search: state.filters.search.concat(
        `${(state.filters.search === "" ? "" : ",") + state.filters.action}`
      ),
      course_names: state.filters.course_names,
    };

    const apiUrl = buildApiUrl(baseUrl, apiParams);

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.get(apiUrl, config);

      commit("SET_APP_ACTION_LOGS", response.data.data);
      commit("SET_PAGINATION", {
        current_page: response.data.current_page || 1,
        per_page: response.data.per_page || 10,
        total: response.data.total || 0,
        last_page: response.data.last_page || 1,
        from: response.data.from || 0,
        to: response.data.to || 0,
      });
    } catch (error) {
      dispatch(
        "toastNotification/displayToast",
        {
          message:
            error?.response?.data?.message || "Failed to fetch app action logs",
          type: "warning",
        },
        { root: true }
      );
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async fetchLatestActionLogs({ commit, dispatch }) {
    commit("SET_LATEST_LOGS_LOADING", true);

    const url = process.env.VUE_APP_API_URL + "/devices/latest-logs";

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.get(url, config);

      commit("SET_LATEST_LOGS", response.data.data);
    } catch (error) {
      dispatch(
        "toastNotification/displayToast",
        {
          message:
            error?.response?.data?.message ||
            "Failed to fetch latest app action logs",
          type: "warning",
        },
        { root: true }
      );
    } finally {
      commit("SET_LATEST_LOGS_LOADING", false);
    }
  },

  setFilters({ commit }, filters) {
    commit("SET_FILTERS", filters);
  },

  setPagination({ commit }, pagination) {
    commit("SET_PAGINATION", pagination);
  },

  resetActionLogs({ commit }) {
    commit("SET_APP_ACTION_LOGS", []);
    commit("RESET_FILTERS");
    commit("SET_PAGINATION", {
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1,
      from: 0,
      to: 0,
    });
  },
};

const buildApiUrl = (baseUrl, params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      if (key === "course_names" && Array.isArray(value)) {
        value.forEach((courseName) => {
          if (courseName.trim() !== "") {
            searchParams.append("course_names[]", courseName);
          }
        });
      } else {
        searchParams.append(key, value);
      }
    }
  });

  return `${baseUrl}?${searchParams.toString()}`;
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
